// extracted by mini-css-extract-plugin
module.exports = {"root":"TranslateIcon_root__25Y6d","root__nonDefault":"TranslateIcon_root__nonDefault__1wjs2"};